import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";
import {formatDate} from '../../../../helpers/utils';
import IconLink from '../../../../common/components/link/IconLink';
import InspectionQtyTrends from './InspectionQtyTrends';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const sliderSettings = {
	dots: false,
	arrows: false,
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	vertical: true,
	verticalSwiping: true,
	autoplay: true,
	autoplaySpeed: 6000,
	pauseOnHover: true
};

const LocationCustomerDashboard2 = (props) => {
	const {state: parentState, permissionNames, translate, enableViewInspection} = props;
	const {
		totalOpenWorkOrders, workOrders, inspections, inspectionsLast3days, inspectionsLast7days
	} = parentState;

	return (
		<Fragment>
			<div className='row'>
				<div className='col-sm-12'>
					<div className="small-box bg-teal-active">
						<div className="inner text-center">
							<p>{translate('dashboard_page_location_customer_total_open_work_orders')}</p>
							<h3>{totalOpenWorkOrders}</h3>
						</div>
						<div className="icon">
							<i className="fa fa-book"/>
						</div>
					</div>
				</div>
			</div>

			{
				workOrders.length > 0 && (
					<div className="row">
						<div className="col-sm-12">
							<div className="box">
								<div className="box-body with-top-padding">
									<Slider {...sliderSettings}>
										{
											workOrders.map((workOrder, index) => {
												const workOrderId = workOrder.id;

												const partNumbers = workOrder.parts.map(obj => obj.number);
												let sumTotalInspected = 0;
												let sumTotalDefect = 0;
												let sumTotalRework = 0;

												const barChartDataLast3days = {
													totalInspected: 0,
													totalCertified: 0,
													totalRejected: 0,
													percentageDefect: 0
												};
												if (inspectionsLast3days[workOrderId]) {
													sumTotalInspected = parseInt(inspectionsLast3days[workOrderId][0].sum_total_inspected, 10);
													sumTotalDefect = parseInt(inspectionsLast3days[workOrderId][0].sum_total_defect, 10);
													sumTotalRework = parseInt(inspectionsLast3days[workOrderId][0].sum_total_rework, 10);

													barChartDataLast3days.totalInspected = sumTotalInspected;
													barChartDataLast3days.totalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
													barChartDataLast3days.totalRejected = sumTotalDefect - sumTotalRework;
													if(sumTotalInspected) {
														barChartDataLast3days.percentageDefect = parseFloat((sumTotalDefect / sumTotalInspected) * 100).toFixed(2);
													}
												}

												const barChartDataLast7days = {
													totalInspected: 0,
													totalCertified: 0,
													totalRejected: 0,
													percentageDefect: 0
												};
												if (inspectionsLast7days[workOrderId]) {
													sumTotalInspected = parseInt(inspectionsLast7days[workOrderId][0].sum_total_inspected, 10);
													sumTotalDefect = parseInt(inspectionsLast7days[workOrderId][0].sum_total_defect, 10);
													sumTotalRework = parseInt(inspectionsLast7days[workOrderId][0].sum_total_rework, 10);

													barChartDataLast7days.totalInspected = sumTotalInspected;
													barChartDataLast7days.totalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
													barChartDataLast7days.totalRejected = sumTotalDefect - sumTotalRework;
													if(sumTotalInspected) {
														barChartDataLast7days.percentageDefect = parseFloat((sumTotalDefect / sumTotalInspected) * 100).toFixed(2);
													}
												}

												const barChartData = {
													totalInspected: 0,
													totalCertified: 0,
													totalRejected: 0,
													percentageDefect: 0
												};
												if (inspections[workOrderId]) {
													sumTotalInspected = parseInt(inspections[workOrderId][0].sum_total_inspected, 10);
													sumTotalDefect = parseInt(inspections[workOrderId][0].sum_total_defect, 10);
													sumTotalRework = parseInt(inspections[workOrderId][0].sum_total_rework, 10);

													barChartData.totalInspected = sumTotalInspected;
													barChartData.totalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
													barChartData.totalRejected = sumTotalDefect - sumTotalRework;
													if(sumTotalInspected) {
														barChartData.percentageDefect = parseFloat((sumTotalDefect / sumTotalInspected) * 100).toFixed(2);
													}
												}

												return (
													<Fragment key={`dashboard_page_location_customer_activity_${index}`}>
														<div className="table-responsive">
															<table className="table table-border text-center">
																<thead>
																	<tr>
																		<th>{translate('dashboard_page_location_customer_activity_work_order_code')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_work_order_customer_name')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_last_3_days')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_percentage_defect')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_last_7_days')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_percentage_defect')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_since_start_date')}</th>
																		<th>{translate('dashboard_page_location_customer_activity_percentage_defect')}</th>
																	</tr>
																</thead>
																<tbody>
																	<tr>
																		<td>
																			{
																				permissionNames && permissionNames.includes('view_inspection') && enableViewInspection
																					? <IconLink type="link" to={`/inspections/detail/${workOrder.id}`} text={workOrder.code}/>
																					: workOrder.code
																			}
																			<p>Start: {formatDate(workOrder.start_date)}</p>
																		</td>
																		<td>{workOrder.customer ? workOrder.customer.name : ''}</td>
																		<td style={{width: "20%"}}>
																			<InspectionQtyTrends data={[
																				{name: 'Total Inspected', value: barChartDataLast3days.totalInspected, fill: "#2c7be5"},
																				{name: 'Total Certified', value: barChartDataLast3days.totalCertified, fill: "#00a65a"},
																				{name: 'Total Rejected', value: barChartDataLast3days.totalRejected, fill: "#dd4b39"}
																			]}/>
																		</td>
																		<td style={{width: "10%"}}>
																			<div className="small-box bg-gray" style={{marginTop: "20px"}}>
																				<div className="inner">
																					<h4>{barChartDataLast3days.percentageDefect}%</h4>
																				</div>
																			</div>
																		</td>
																		<td style={{width: "20%"}}>
																			<InspectionQtyTrends data={[
																				{name: 'Total Inspected', value: barChartDataLast7days.totalInspected, fill: "#2c7be5"},
																				{name: 'Total Certified', value: barChartDataLast7days.totalCertified, fill: "#00a65a"},
																				{name: 'Total Rejected', value: barChartDataLast7days.totalRejected, fill: "#dd4b39"}
																			]}/>
																		</td>
																		<td style={{width: "10%"}}>
																			<div className="small-box bg-gray" style={{marginTop: "20px"}}>
																				<div className="inner">
																					<h4>{barChartDataLast7days.percentageDefect}%</h4>
																				</div>
																			</div>
																		</td>
																		<td style={{width: "20%"}}>
																			<InspectionQtyTrends data={[
																				{name: 'Total Inspected', value: barChartData.totalInspected, fill: "#2c7be5"},
																				{name: 'Total Certified', value: barChartData.totalCertified, fill: "#00a65a"},
																				{name: 'Total Rejected', value: barChartData.totalRejected, fill: "#dd4b39"}
																			]}/>
																		</td>
																		<td style={{width: "10%"}}>
																			<div className="small-box bg-gray" style={{marginTop: "20px"}}>
																				<div className="inner">
																					<h4>{barChartData.percentageDefect}%</h4>
																				</div>
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td colSpan={8}>
																			Job Description: {workOrder.job_description}
																		</td>
																	</tr>
																	<tr>
																		<td colSpan={8}>
																			<div style={{maxHeight: "40px", overflow: "hidden"}}>
																				Parts: {partNumbers.join(', ')}
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</Fragment>
												);
											})
										}
									</Slider>
								</div>
							</div>
						</div>
					</div>
				)
			}
		</Fragment>
	);
};

LocationCustomerDashboard2.defaultProps = {
	enableViewInspection: true
};

LocationCustomerDashboard2.propTypes = {
	state: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	enableViewInspection: PropTypes.bool
};

export default LocationCustomerDashboard2;
